import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  BudgetContainer,
  Title,
  Description,
  Subtitle,
  SectionTitleContainer,
  SectionIcon,
  SectionTitle,
  SectionSubtitle,
  BudgetTotal,
  BudgetGraphsContainer,
  NoRecordsContainer,
  NoRecords,
  BudgetInfo,
  OptionButton,
} from "./BudgetStyles";
import Hand from "../../assets/icons/hand.svg";
import CreditCard from "../../assets/icons/credit.svg";
import Money from "../../assets/icons/money.svg";
import BudgetSection from "../../components/budgetSection/BudgetSection";
import BudgetGraph from "../../components/budgetGraph/BudgetGraph";
import { CreateBudget, MyBudget, RemoveBudget } from "../../infra/requests/MyWeddingRequests";
import moment from "moment";
import { SpinLoading } from "../../styles/BasicStyles";
import { numberFormat } from "../../infra/services/utils/FormatNumber";
import BudgetTablePayments from "../../components/budgetTable/BudgetTablePayments";
import BudgetTableExpenses from "../../components/budgetTable/BudgetTableExpenses";
import { GetUpgradeDetail } from "../../infra/requests/UpgradeRequests";
import { inGuestMapTest } from "../../infra/services/utils/Helpers";
import { renderBudgetNotes, isPhaseCompleteByMissing } from "./budgetUtils";
import { GraphColors, PrimaryColour } from "../../styles/Colours";
import SaveButton from "../../components/buttons/SaveButton";
import PaymentProofModal from "./PaymentProofModal";
import PaymentPhasesBudget from "./PaymentPhasesBudget";
import { processClosed } from "../../infra/services/utils/BlockAnswers";
import { FlattenToFormData } from "../../infra/services/validations/TransformToFormData";
import Alerts from "../../components/alert/Alert";
import { WeddingStatus } from "../reserve/ReservePage";
import { SaveWedding, updateAboutUsAction } from "../../redux/Wedding/wedding.actions";
import { UPDATE_ABOUT_US } from "../../redux/ActionsType";

class Budget extends Component {
  state = {
    payments: [],
    expenses: [],
    expensesExtras: [],
    numTables: 0,
    numGuests: 0,
    minGuests: 0,
    numPlaces: 0,
    numChildren: 0,
    numStaff: 0,
    staffQtt: 0,
    staffPrice: 0,
    staffExtraQtt: 0,
    staffExtraPrice: 0,
    numPax: 0,
    numPaxShow: 0,
    people: 0,
    maxPax: 0,
    submittedRoomPlan: false,
    music: 0,
    priceGuest: 0,
    paymentsList: [],
    expensesList: [],
    offersList: [],
    receiptsList: [],
    discountsList: [],
    total: 0,
    offer: null,
    discount: null,
    upgrade: undefined,
    paymentPhases: [],
    firstSecondPhasesPrices: [],
    iban: '',
    swift: '',
    local: 1,
    ready: false,

    isProcessClosed: false,

    canOpenReceiptModal: false,
    receiptModalVisible: false,
    currentReceipt: {},
    receiptOnlyView: false,

    appliedPaymentProofs: [],
    ourStaffExtraPrice: 0
  };

  componentDidMount() {
    const { info, weddingInfo } = this.props;

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    document.body.style.overflowY = 'auto';

    const canOpenReceiptModal = (weddingInfo && weddingInfo?.contractDate) ? true : false;

    const isProcessClosed = processClosed(weddingInfo?.blockDate);
    this.setState({
      iban: info?.configs?.iban || '',
      swift: info?.configs?.swift || '',
      local: info?.configs?.local || 1,
      isProcessClosed,
      canOpenReceiptModal
    }, () => this.getBudget());
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.info?.configs?.iban != this.props?.info?.configs?.iban) {
      this.setState({ iban: this.props?.info?.configs?.iban || '' });
    }

    if (prevProps?.info?.configs?.swift != this.props?.info?.configs?.swift) {
      this.setState({ swift: this.props?.info?.configs?.swift || '' });
    }

    if (prevProps?.info?.configs?.local != this.props?.info?.configs?.local) {
      this.setState({ local: this.props?.info?.configs?.local || 1 });
    }
  }

  addReceipt = async (data) => {
    const { weddingInfo } = this.props;
    const { translate, dispatch } = this.props;

    if (!data?.description) data['description'] = ' ';
    data['value'] = 0;
    data['title'] = ' ';
    data['type'] = 'PAYMENT_PROOF';
    data['date'] = moment.utc().toISOString();

    const payload = FlattenToFormData({ ...data, wedding: weddingInfo?._id });
    payload.append('file', data?.receipt?.blob);

    const createdBudget = await CreateBudget(payload);
    if (createdBudget?.success) {
      Alerts.new({
        type: "success",
        title: translate("SUCCESS"),
        text: translate('PAYMENT_PROOF_ADDED_SUCCESS'),
      });

      dispatch(updateAboutUsAction(createdBudget?.data?.wedding));

      this.closeReceiptModal();
      await this.getBudget();
    } else {
      Alerts.new({
        type: "error",
        title: translate("ERROR"),
        text: translate('PAYMENT_PROOF_ADDED_ERROR'),
      });

      this.closeReceiptModal();
    }
  }

  deleteReceipt = async (id) => {
    const { translate } = this.props;

    const removed = await RemoveBudget(id);
    if (removed?.success) {
      Alerts.new({
        type: "success",
        title: translate("SUCCESS"),
        text: translate('PAYMENT_PROOF_REMOVED_SUCCESS'),
      });

      await this.getBudget();
    } else {
      Alerts.new({
        type: "error",
        title: translate("ERROR"),
        text: translate('PAYMENT_PROOF_REMOVED_ERROR'),
      });
    }
  }

  openAddReceiptModal = () => {
    this.setState({ receiptModalVisible: true, receiptOnlyView: false });
  }

  openViewReceiptModal = async (receipt) => {
    this.setState({ receiptModalVisible: true, receiptOnlyView: true, currentReceipt: receipt });
  }

  closeReceiptModal = () => {
    this.setState({ receiptModalVisible: false, receiptOnlyView: false, currentReceipt: {} });
  }

  getBudget = async () => {
    const { weddingInfo } = this.props;

    let { data, success } = await MyBudget();
    let expenses = [],
      expensesExtras = [],
      payments = [],
      paymentsList = [],
      expensesList = [],
      offersList = [],
      receiptsList = [],
      discountsList = [],
      paymentPhases = [],
      firstSecondPhasesPrices = [];
    let total = 0,
      paid = 0,
      missing = 0,
      numTables = 0,
      numGuests = 0,
      minGuests = 0,
      numPlaces = 0,
      numChildren = 0,
      numStaff = 0,
      staffQtt = 0,
      staffPrice = 0,
      staffExtraQtt = 0,
      staffExtraPrice = 0,
      numPax = 0,
      numPaxShow = 0,
      priceGuest = 0,
      people = 0,
      maxPax = 0,
      submittedRoomPlan = false,
      music = 0,
      offer = 0,
      discount = 0,
      upgrade = undefined;

    let ourStaffExtraPrice = 0;

    if (success) {
      expensesExtras = data.extras;
      numTables = data.tables;
      numGuests = data.guests;
      minGuests = data.min_people;
      numPlaces = data.places;
      numChildren = data.children;
      numStaff = data.staff;
      staffQtt = data.staffQtt;
      staffPrice = data.staffPrice;
      staffExtraQtt = data.staffExtraQtt;
      staffExtraPrice = data.staffExtraPrice;
      music = data.music;
      offer = data?.offer;
      discount = data?.discount;
      numPax = data.pax;
      numPaxShow = data.pax_show;
      priceGuest = data.price;
      paymentPhases = data?.paymentPhases || [];
      firstSecondPhasesPrices = data?.firstSecondPhasesPrices || [];
      ourStaffExtraPrice = data?.ourStaffExtraPrice || 0;
      people = data?.people || 0;
      maxPax = data?.maxPax || 0;
      submittedRoomPlan = data?.submittedRoomPlan || false;

      // eslint-disable-next-line
      for (let key in data.costs) {
        if (key !== 'offer' && key !== 'discount') {
          total += parseFloat(data.costs[key]);
        }
      }

      //Offers
      const offers = parseFloat(data.costs.offer) || 0;
      //Discounts
      const discounts = parseFloat(data.costs.discount) || 0;
      total = total - offers - discounts;

      if (data.budget.length > 0) {
        paymentsList = data.budget.filter((budget) =>
          budget.type === "PAYMENT" ? budget : null
        );
        expensesList = data.budget.filter((budget) =>
          budget.type === "EXPENSE" ? budget : null
        );
        offersList = data.budget.filter((budget) =>
          budget.type === "OFFER" ? budget : null
        );
        receiptsList = data.budget.filter((budget) =>
          budget.type === "PAYMENT_PROOF" ? budget : null
        );
        discountsList = data.budget.filter((budget) =>
          budget.type === "DISCOUNT" ? budget : null
        );

        if (paymentsList.length > 0) {
          for (let i = 0; i < paymentsList.length; i++) {
            paid += paymentsList[i].value;
          }
        }
      }

      // Falta agregada nunca negativa (sobre-pagamento não deve gerar fatia negativa no gráfico)
      missing = Math.max(0, total - paid);

      payments = [
        {
          name: "BUDGET_PAID",
          value: paid,
          color: GraphColors.paid,
        },
        {
          name: "BUDGET_MISSING",
          value: missing,
          color: GraphColors.missing,
        },
      ];

      expenses = [
        {
          name: "BUDGET_ADJUDICATED",
          value: data.costs.base,
          color: GraphColors.base,
        },
        {
          name: 'BUDGET_ROOM_PLAN',
          value: data.costs.tables,
          color: GraphColors.roomPlan,
        },
        {
          name: "BUDGET_CEREMONY",
          value: data.costs.ceremony,
          color: GraphColors.ceremony,
        },
        {
          name: "BUDGET_STAFF",
          value: data.costs.staff,
          color: GraphColors.staff,
        },
        {
          name: "BUDGET_FOOD",
          value: data.costs.food,
          color: GraphColors.food,
        },
        {
          name: "BUDGET_DRINK",
          value: data.costs.drinks,
          color: GraphColors.drinks,
        },
        {
          name: "BUDGET_DECORATION",
          value: data.costs.decoration,
          color: GraphColors.decor,
        },
        {
          name: "BUDGET_PARTY",
          value: data.costs.party,
          color: GraphColors.party,
        },
        {
          name: "BUDGET_UPGRADE",
          value: data.costs.upgrade,
          color: GraphColors.upgrade,
        },
        {
          name: "BUDGET_EXPENSES",
          value: data.costs.expense,
          color: GraphColors.expense,
        }
      ];
    }

    const appliedPaymentProofs = success && data?.appliedPaymentProofs ? data?.appliedPaymentProofs : [];

    if (weddingInfo?.upgrade) {
      ({ data, success } = await GetUpgradeDetail(weddingInfo?.upgrade._id ? weddingInfo?.upgrade._id : weddingInfo?.upgrade));

      if (success) {
        upgrade = data;
      }
    }

    const staffBudget = expenses.find(e => e?.name === 'BUDGET_STAFF');
    // staffBudget.value += ourStaffExtraPrice;

    this.setState({
      payments,
      expenses,
      expensesExtras,
      numTables,
      numGuests,
      minGuests,
      numPlaces,
      numChildren,
      numStaff,
      staffQtt,
      staffPrice,
      staffExtraQtt,
      staffExtraPrice,
      numPax,
      numPaxShow,
      music,
      priceGuest,
      paymentsList,
      expensesList,
      offersList,
      receiptsList,
      discountsList,
      total,
      offer,
      discount,
      upgrade,
      paymentPhases,
      firstSecondPhasesPrices,
      ready: true,
      appliedPaymentProofs,
      ourStaffExtraPrice,
      people,
      maxPax,
      submittedRoomPlan
    });
  };

  renderPrice = (price) => {
    if (price !== undefined) price = parseFloat(price);
    return `${numberFormat(price || 0, 2, ",", ".")}€`;
  };

  showConfirmedInfo = (onlyConfirmed = false) => {
    const { weddingInfo } = this.props;
    if (onlyConfirmed) {
      return (weddingInfo?.status === WeddingStatus.CONFIRMED);
    }
    return (weddingInfo?.status === WeddingStatus.RESERVE_SINALIZATION || weddingInfo?.status === WeddingStatus.CONFIRMED);
  };

  isPhaseComplete = (order) => {
    const { paymentPhases } = this.state;
    const phase = paymentPhases.find(p => p?.order === order);
    if (!phase) {
      return false;
    }

    // Regra única: fase completa quando a falta for <= 50 €.
    return isPhaseCompleteByMissing(phase);
  }

  isPaymentProofUsedOnPayment = (register) => {
    const { weddingInfo } = this.props;

    const mainColor = weddingInfo?.wedding_place === 1 ? '#f7c0b9' : weddingInfo?.wedding_place === 2 ? '#a3d2bb' : '#faf9f9';
    const applied = this.state.appliedPaymentProofs.find(p => p?._id === register?._id);

    if (!applied) {
      return mainColor
    }

    return "#fff";
  }


  weddingDateHasPassed = () => {
    const { weddingInfo } = this.props;
    if (!weddingInfo?.date) return false;

    const weddingDate = moment.utc(weddingInfo.date);
    const today = moment.utc();
    return weddingDate.isBefore(today);
  }

  openContract = () => {
    const { weddingInfo } = this.props;
    const fileId = weddingInfo?.contractFile?._id ? weddingInfo?.contractFile?._id : weddingInfo?.contractFile;
    const fileURL = `${process.env.REACT_APP_API}/files/${fileId}`;
    window.open(fileURL, '_blank');
  }

  ifPhaseComplete = (phaseOrder) => {
    const { paymentPhases } = this.state;
    const phase = paymentPhases.find(p => p?.order === phaseOrder);
    if (!phase) {
      return false;
    }
    // Regra única: fase completa quando a falta for <= 50 €.
    return isPhaseCompleteByMissing(phase);
  }

  refreshStaffPrice = (expenses) => {

  }

  render() {
    const { activeLanguage, translate, weddingInfo } = this.props;
    const {
      payments,
      expenses,
      expensesExtras,
      numTables,
      numGuests,
      minGuests,
      numPlaces,
      music,
      numChildren,
      numStaff,
      staffQtt,
      staffPrice,
      staffExtraQtt,
      staffExtraPrice,
      numPax,
      numPaxShow,
      priceGuest,
      paymentsList,
      expensesList,
      offersList,
      receiptsList,
      discountsList,
      total,
      upgrade,
      ready,
      ourStaffExtraPrice,
      people,
      maxPax,
      submittedRoomPlan
    } = this.state;
    const { iban, swift, local } = this.state;
    const { paymentPhases, firstSecondPhasesPrices } = this.state;
    const { receiptModalVisible, canOpenReceiptModal, currentReceipt, receiptOnlyView } = this.state;
    const { isProcessClosed } = this.state;

    if (!ready) return <SpinLoading />;

    const mainColor = weddingInfo?.wedding_place === 1 ? '#f7c0b9' : weddingInfo?.wedding_place === 2 ? '#a3d2bb' : '#faf9f9';

    return (
      <BudgetContainer>
        <Title>{translate("ESTIMATED_BUDGET")}</Title>
        <Description>{translate("BUDGET_TEXT")}</Description>
        <BudgetTotal>
          {`${translate("TOTAL_VALUE")}: ${numberFormat(total, 2, ",", ".")}€`}
        </BudgetTotal>
        <BudgetGraphsContainer>
          <div className="graph1">
            <BudgetGraph title={translate("PAYMENTS")} data={payments} />
            <BudgetInfo>
              <ul>
                {this.showConfirmedInfo() && weddingInfo?.updatedBudget &&
                  <li className='updated line'>
                    <div className="title">{translate('UPDATED_ON')}:</div>
                    <span>{moment.utc(weddingInfo?.updatedBudget).format('DD/MM/YYYY HH:mm')}</span>
                  </li>}
                {iban && paymentsList?.length > 0 &&
                  <React.Fragment>
                    <li>
                      <Subtitle payment={true}>{translate('PAYMENT_DATA')}</Subtitle>
                    </li>
                    <li className='iban' style={{ marginBottom: '0px' }}>
                      <div>{translate('ZONE_NAME')}:</div>
                      <span>{local === 1 ? 'Solar da Levada' : local === 2 ? 'Quinta Lago dos Cisnes' : ''}</span>
                    </li>
                    <li className='iban' style={{ marginBottom: '0px' }}>
                      <div>{translate('IBAN')}:</div>
                      <span>{iban || ''}</span>
                    </li>
                    <li className='iban' style={{ marginBottom: '0px' }}>
                      <div>{translate('SWIFT_CODE')}:</div>
                      <span>{swift || ''}</span>
                    </li>
                    <li className='iban line'>
                      <div>{translate('BANK')}:</div>
                      <span>Crédito Agrícola</span>
                    </li>
                  </React.Fragment>
                }
                {this.showConfirmedInfo() && Array.isArray(paymentPhases) && paymentPhases.length > 0 && (
                  <React.Fragment>
                    <li>
                      <Subtitle payment={true}>{translate('PAYMENT_STAGES')}</Subtitle>
                    </li>
                    <PaymentPhasesBudget
                      paymentPhases={paymentPhases}
                      weddingInfo={weddingInfo}
                      translate={translate}
                      activeLanguage={activeLanguage}
                      renderPrice={this.renderPrice}
                      weddingDateHasPassed={this.weddingDateHasPassed()}
                      ifPhaseComplete={(phaseOrder) => this.ifPhaseComplete(phaseOrder)}
                      openContract={() => this.openContract()}
                    />
                  </React.Fragment>
                )}
              </ul>
            </BudgetInfo>
            <div class="line" style={{ textAlign: 'left', fontSize: '13px' }}>
              <div style={{ fontWeight: 'bold' }}>{translate('NOTES')}: </div>
              {renderBudgetNotes(translate)}
            </div>
          </div>
          <BudgetGraph title={translate("EXPENSES")} data={expenses} />
        </BudgetGraphsContainer>
        <Subtitle>{translate("PAYMENTS_MADE")}</Subtitle>
        <BudgetTablePayments payments={payments} />
        {this.showConfirmedInfo() && <React.Fragment>
          <BudgetTableExpenses
            expenses={expenses}
            expensesExtras={expensesExtras}
            expensesList={expensesList}
            offersList={offersList}
            receiptsList={receiptsList}
            discountsList={discountsList}
            numTables={numTables}
            numGuests={numGuests}
            minGuests={minGuests}
            numPlaces={numPlaces}
            numChildren={numChildren}
            numStaff={numStaff}
            staffQtt={staffQtt}
            staffPrice={staffPrice}
            staffExtraQtt={staffExtraQtt}
            staffExtraPrice={staffExtraPrice}
            numPax={numPax}
            numPaxShow={numPaxShow}
            music={music}
            priceGuest={priceGuest}
            upgrade={upgrade}
            weddingInfo={weddingInfo}
            ourStaffExtraPrice={ourStaffExtraPrice}
            people={people}
            maxPax={maxPax}
            submittedRoomPlan={submittedRoomPlan}
          />
        </React.Fragment>
        }
        {/* Payments */}
        <SectionTitleContainer>
          <SectionIcon src={Hand} />
          <SectionTitle>{translate("PAYMENTS_MADE")}</SectionTitle>
        </SectionTitleContainer>
        <SectionSubtitle>{translate("PAYMENTS_TEXT")}</SectionSubtitle>
        {paymentsList.length > 0 ? (
          paymentsList.map((payment, index) => (
            <BudgetSection
              phaseConcluded={this.isPhaseComplete(payment?.phase)}
              type={payment?.type}
              mainColor={mainColor}
              key={index}
              title={payment.title}
              section=""
              text={payment.description}
              amount={`-${numberFormat(payment.value, 2, ",", ".")}€`}
              date={`${translate("DATE")}: ${moment(payment.date)
                .utc()
                .format("DD/MM/YYYY")}`}
            />
          ))
        ) : (
          <NoRecordsContainer>
            <NoRecords>{translate("BUDGET_NO_PAYMENTS")}</NoRecords>
          </NoRecordsContainer>
        )}

        {this.showConfirmedInfo(true) && <React.Fragment>
          {/* Discounts */}
          <SectionTitleContainer>
            <SectionIcon src={Hand} />
            <SectionTitle>{translate("DISCOUNTS_TITLE")}</SectionTitle>
          </SectionTitleContainer>
          <SectionSubtitle>{translate("DISCOUNTS_TEXT")}</SectionSubtitle>
          {discountsList.length > 0 && (
            discountsList
              .sort((a, b) => {
                if (b?.markedExtraDiscount && !a?.markedExtraDiscount) return 1;
                if (a?.markedExtraDiscount && !b?.markedExtraDiscount) return -1;
                return 0;
              })
              .map((discount, index) => (
                discount.markedExtraDiscount
                  ? <BudgetSection
                    key={index}
                    title={discount.extraDiscountTitleTranslation[activeLanguage?.code]}
                    section=""
                    text={discount.extraDiscountDescriptionTranslation[activeLanguage?.code]}
                    amount={`-${numberFormat(discount.value, 2, ",", ".")}€`}
                    date={`${translate("DATE")}: ${moment(discount.date)
                      .utc()
                      .format("DD/MM/YYYY")}`}
                  />
                  : <BudgetSection
                    key={index}
                    title={discount.title}
                    section=""
                    text={discount.description}
                    amount={`-${numberFormat(discount.value, 2, ",", ".")}€`}
                    date={`${translate("DATE")}: ${moment(discount.date)
                      .utc()
                      .format("DD/MM/YYYY")}`}
                  />
              ))
          )}

          {/* Expenses */}
          <SectionTitleContainer>
            <SectionIcon src={Money} />
            <SectionTitle>{translate("EXPENSES_TITLE")}</SectionTitle>
          </SectionTitleContainer>
          <SectionSubtitle>{translate("EXPENSES_TEXT")}</SectionSubtitle>
          {expensesList.length > 0 ? (
            expensesList.map((expense, index) => (
              <BudgetSection
                key={index}
                title={expense.title}
                section=""
                text={expense.description}
                amount={`+${numberFormat(expense.value, 2, ",", ".")}€`}
                date={`${translate("DATE")}: ${moment(expense.date)
                  .utc()
                  .format("DD/MM/YYYY")}`}
              />
            ))
          ) : (
            <NoRecordsContainer>
              <NoRecords>{translate("BUDGET_NO_EXPENSES")}</NoRecords>
            </NoRecordsContainer>
          )}

          {/* OFFERS */}
          <SectionTitleContainer>
            <SectionIcon src={Hand} />
            <SectionTitle>{translate("OFFERS_TITLE")}</SectionTitle>
          </SectionTitleContainer>
          <SectionSubtitle>{translate("OFFERS_TEXT")}</SectionSubtitle>
          {offersList.length > 0 && (
            offersList.map((offer, index) => (
              <BudgetSection
                key={index}
                title={offer.title}
                section=""
                text={offer.description}
                amount={`-${numberFormat(offer.value, 2, ",", ".")}€`}
                date={`${translate("DATE")}: ${moment(offer.date)
                  .utc()
                  .format("DD/MM/YYYY")}`}
              />
            ))
          )}
        </React.Fragment>}

        {/* RECEIPTS */}
        <SectionTitleContainer>
          <SectionIcon src={Hand} />
          <SectionTitle>{translate("PAYMENT_PROOF_TITLE")}</SectionTitle>
        </SectionTitleContainer>
        <SectionSubtitle>{translate("PAYMENT_PROOF_TEXT")}</SectionSubtitle>
        {receiptsList.length > 0 && (
          receiptsList.map((offer, index) => (
            <BudgetSection
              mainColor={this.isPaymentProofUsedOnPayment(offer)}
              type={offer.type}
              document={offer.document}
              billing={offer.billing}
              key={index}
              title={offer.title}
              section=""
              text={offer.description}
              amount={`-${numberFormat(offer.value, 2, ",", ".")}€`}
              budget={offer}
              date={`${translate("DATE")}: ${moment(offer.date)
                .utc()
                .format("DD/MM/YYYY")}`}
              translate={translate}
              onDelete={() => this.deleteReceipt(offer?._id)}
              onOpenView={() => this.openViewReceiptModal(offer)}
            />
          ))
        )}

        {/* Iban */}
        {paymentsList?.length > 0 && <React.Fragment>
          <SectionTitleContainer>
            <SectionIcon src={CreditCard} />
            <SectionTitle>{translate("IBAN")}</SectionTitle>
          </SectionTitleContainer>
          <SectionSubtitle>{iban || ''} {swift || ''}</SectionSubtitle>
        </React.Fragment>}

        {weddingInfo.status !== 'R' && <SaveButton
          htmlType="submit"
          text={translate("ADD_PAYMENT_PROOF")}
          textMobile={translate("PAYMENT_PROOF")}
          onClick={() => this.openAddReceiptModal()}
        />}

        {receiptModalVisible && <PaymentProofModal open={receiptModalVisible}
          activeLanguage={activeLanguage}
          wedding={weddingInfo}
          type={'PAYMENT_PROOF'}
          closeModal={() => this.closeReceiptModal()}
          onSubmit={(data) => this.addReceipt(data)}
          translate={translate}
          initialValues={currentReceipt}
          onlyView={receiptOnlyView}
          isProcessClosed={isProcessClosed} />}
      </BudgetContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  weddingInfo: state.wedding.wedding,
  configs: state.info.configs,
  info: state.info
});

// const mapActionToProps = (dispatch) =>
//   bindActionCreators({ SaveWedding }, dispatch);

const mapActionToProps = (dispatch) => ({
  dispatch,
  updateAboutUsAction: (data) => dispatch(updateAboutUsAction(data)),
})

export default withLocalize(connect(mapStateToProps, mapActionToProps)(Budget));
